import { KybDocumentRequirementTarget } from "@/core/kyb/entities/KybPerimeter";

// Chemins relatifs à la base `/api/v1` du client HTTP.
const base = "/compliance/kyb";
const enc = encodeURIComponent;

/** Exigence d'un type de pièce : défaut du pays ou forme juridique. */
const requirementPath = (countryCode: string, target: KybDocumentRequirementTarget): string =>
  target.formeCode
    ? `${base}/document-requirements/countries/${enc(countryCode)}/formes/${enc(target.formeCode)}/types/${enc(target.typePieceCode)}`
    : `${base}/document-requirements/countries/${enc(countryCode)}/defaults/types/${enc(target.typePieceCode)}`;

const formeQuery = (target: KybDocumentRequirementTarget): string => (target.formeCode ? `formeCode=${enc(target.formeCode)}` : "");

const kybPerimeterEndpoints = {
  countryScopes: () => `${base}/country-scopes`,
  countryScope: (countryCode: string) => `${base}/country-scopes/${enc(countryCode)}`,
  activateCountryScope: (countryCode: string) => `${base}/country-scopes/${enc(countryCode)}/activate`,
  deactivateCountryScope: (countryCode: string) => `${base}/country-scopes/${enc(countryCode)}/deactivate`,

  legalForms: (countryCode: string) => `${base}/legal-form-rules/countries/${enc(countryCode)}`,
  legalForm: (countryCode: string, formeCode: string) => `${base}/legal-form-rules/countries/${enc(countryCode)}/formes/${enc(formeCode)}`,
  activateLegalForm: (countryCode: string, formeCode: string) =>
    `${base}/legal-form-rules/countries/${enc(countryCode)}/formes/${enc(formeCode)}/activate`,
  deactivateLegalForm: (countryCode: string, formeCode: string) =>
    `${base}/legal-form-rules/countries/${enc(countryCode)}/formes/${enc(formeCode)}/deactivate`,

  requirements: (countryCode: string) => `${base}/document-requirements/countries/${enc(countryCode)}`,
  requirement: requirementPath,
  activateRequirement: (countryCode: string, target: KybDocumentRequirementTarget) => {
    const query = formeQuery(target);
    const queryString = query ? `?${query}` : "";
    return `${base}/document-requirements/countries/${enc(countryCode)}/types/${enc(target.typePieceCode)}/activate${queryString}`;
  },
  deactivateRequirement: (countryCode: string, target: KybDocumentRequirementTarget) => {
    const query = formeQuery(target);
    const queryString = query ? `?${query}` : "";
    return `${base}/document-requirements/countries/${enc(countryCode)}/types/${enc(target.typePieceCode)}/deactivate${queryString}`;
  },
  activateDrafts: (countryCode: string) => `${base}/perimeter/countries/${enc(countryCode)}/activate-drafts`,
  deleteRequirement: (countryCode: string, target: KybDocumentRequirementTarget, expectedVersion: number) => {
    const query = [formeQuery(target), `expectedVersion=${expectedVersion}`].filter(Boolean).join("&");
    return `${base}/document-requirements/countries/${enc(countryCode)}/types/${enc(target.typePieceCode)}?${query}`;
  },

  versions: (countryCode: string) => `${base}/ref-versions/countries/${enc(countryCode)}`,
  versionDraft: (countryCode: string) => `${base}/ref-versions/countries/${enc(countryCode)}/draft`,
  compare: (fromVersionId: string, toVersionId: string) => `${base}/ref-versions/diff?from=${enc(fromVersionId)}&to=${enc(toVersionId)}`,
  version: (versionId: string) => `${base}/ref-versions/${enc(versionId)}`,
  simulate: (versionId: string) => `${base}/ref-versions/${enc(versionId)}/simulate`,
  publish: (versionId: string) => `${base}/ref-versions/${enc(versionId)}/publish`,

  legalFormReferences: () => "/bank/formes-juridiques?page=0&size=300",
};

export default kybPerimeterEndpoints;
